import { useMemo } from 'react'
import { Heading, Text, CSSObject } from '@ritualco/jutsu'
import { CardPage } from 'components/PageTemplates'
import {
  WorkspaceSelector,
  WorkspaceChangeProps,
} from 'components/WorkspaceSelector'
import { useContent } from 'lib/content/react'
import { mapToWorkspaceList } from 'api/mappers/workspace'
import { WorkspacesResponse } from 'lib/generated/api'
import { useGetOrganizationsWorkspaces } from 'api/endpoints/workspaces'
import { useStore } from 'state/store'
import { UseQueryResult } from 'react-query'

export type WorkspaceSwitcherProps = {
  onWorkspaceSelect?: (ids: WorkspaceChangeProps) => void
}

const userIdentifierStyles: CSSObject = {
  color: 'grayscale.primary',
  fontSize: 'xsmall',
  textAlign: 'center',
  mt: 9,
  mb: 8,
}

const WorkspaceSwitcher = ({
  onWorkspaceSelect = () => {},
}: WorkspaceSwitcherProps) => {
  const { formatMessage } = useContent()

  const userEmail = useStore(state => state.userInfo.email)
  const organizations = useStore(state => state.attachedOrganizations)
  const workspacesQueries = useGetOrganizationsWorkspaces(
    organizations.map(organization => ({ organizationId: organization.id }))
  ) as UseQueryResult<WorkspacesResponse, any>[]
  const workspaces = useMemo(() => {
    return workspacesQueries
      .map(response => {
        const { data: workspaceResponse } = response
        return workspaceResponse?.results.length
          ? mapToWorkspaceList(workspaceResponse)
          : []
      })
      .reduce((accumulator, item) => {
        return item.length ? accumulator.concat(item) : accumulator
      }, [])
  }, [workspacesQueries])

  return (
    <CardPage>
      <Heading fontSize="3xlarge" as="h1" textAlign="center">
        {formatMessage({ id: 'pmportal.workspaces.switcherTitle' })}
      </Heading>
      <Text sx={userIdentifierStyles}>
        {formatMessage(
          {
            id: 'pmportal.workspaces.userIdentifier',
          },
          {
            email: () => userEmail,
          }
        )}
      </Text>
      <WorkspaceSelector
        workspaces={workspaces}
        organizations={organizations}
        onWorkspaceChange={onWorkspaceSelect}
      />
    </CardPage>
  )
}

export default WorkspaceSwitcher
